import React, {useEffect, useState} from 'react';
import Header from "./Header";
import usePageViews from "../functions/usePageViews";
import paw from "./../img/favicon.png";
import {
	accordionClasses, Button,
	Checkbox,
	Dialog, DialogActions,
	DialogContent, DialogContentText,
	DialogTitle,
	FormControlLabel,
	Radio,
	RadioGroup
} from "@mui/material";
import Register from "./Register";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import pricingMarkdownFile from './html_pricing.md'
import pricingMarkdownFileCommunity from './html_pricing_community.md'

export default function Landing() {
	
	usePageViews('/register/landing');
	const [accepted, setAccepted] = useState(false);
	const [acceptedType, setAcceptedType] = useState('');
	const [step, setStep] = useState(0);
	
	return (
		<div>
			<Header/>
			<div className="hero background-image">
				<div className={"hero-content"}>
					{(accepted === false || step === 0) ?
						<Hero accepted={accepted} setAccepted={setAccepted} setStep={setStep}
						      setAcceptedType={setAcceptedType}
						      acceptedType={acceptedType}
						/> : undefined}
					{
						(accepted === true && step > 0) ?
							<Register setStep={setStep} acceptedType={acceptedType} />
							: undefined
					}
				</div>
			</div>
			<Footer/>
		</div>
	)
	
}

const Hero = (props) => {
	return (
		<>
			<h2 style={{color: 'orange', marginBottom: 0}}>SPCA Desexing Programme</h2>
			<h1>Register your Veterinary Clinic</h1>
			<p>We would like to work in collaboration with your veterinary practice, and together make an impact on
				the number of unwanted animals being born across the country.</p>
			<p>You will not be locked into the programme – you will have the ability to opt in and out as needed due
				to staffing numbers, busy periods, commitments to other programmes etc.</p>
			<p>We ask that all methods of surgery, including pain control, are up to date with current
				recommendations from the New Zealand Veterinary Association (NZVA).</p>
			<ShowTypesSnip />
			<ShowTypesCommunity />
			<PageHowWork/>
			<PageHowRemuneration/>
			<PageRecognition/>
			<PageAcceptance {...props} />
		</>
	)
}

const ShowTypesSnip = (props) => {
	return (
		<>
			<h3>Snip'n'Chip</h3>
			<p>All SPCA Snip ‘n’ Chip campaigns aim to encourage those who cannot afford and/or may not normally consider having their animal desexed to use this opportunity.  It also provides the opportunity for pet owners that do not currently have a local vet to get to know one.  This campaign targets a large portion of the community who need a helping hand to get their pet desexed.  There will generally only be one campaign, per area, per calendar year.</p>
		
		</>
	)
}

const ShowTypesCommunity = (props) => {
	return (
		<>
			<h3>Community Desexing</h3>
			<p>Community Desexing is different to Snip ‘n’ Chip. This is not advertised to the general public. It is for
				animals that the Centre and Inspectors come across in their day-to-day activities or for people whom
				participating clinics refer to us. There are only a select number of Community Desexing vouchers of
				available, much less than Snip ‘n’ Chip. These vouchers however will be available year-round.</p>
			
			<p>The types of animals you are likely to see through Community Desexing are:</p>
			<ul>
				<li><Favicon/>Animals who are at high risk of being neglected or abandoned.</li>
				<li><Favicon/>Animals who may have had multiple litters.</li>
				<li><Favicon/>Their owners are struggling financially, and there is no current Snip ‘n’ Chip running.</li>
				<li><Favicon/>People with whom the Inspectors are working with.</li>
			</ul>
		
		</>
	)
}

const PageAcceptance = (props) => {
	
	const [community, setCommunity] = useState(false);
	const [pricing, setPricing] = useState(false);
	
	function handleChange(e) {
		props.setAccepted(true);
		props.setAcceptedType(e.target.value);
	}
	
	return (
		<>
			<p>I have read the above and am interested in:</p>
			<div>
				<RadioGroup
					aria-labelledby="demo-controlled-radio-buttons-group"
					name="controlled-radio-buttons-group"
					value={props.acceptedType}
					onChange={handleChange}
				>
					<FormControlLabel value="public" control={<Radio />} label={<>Snip'n'Chip <a href={""} onClick={(e) => {
						e.preventDefault(); setCommunity(false); setPricing(true);
					}}> Show pricing</a></>} />
					<FormControlLabel value="community" control={<Radio />} label={<>Community Desexing <a href={""} onClick={(e) => {
						e.preventDefault(); setCommunity(true); setPricing(true);
					}}> Show pricing</a></>} />
					<FormControlLabel value="both" control={<Radio />} label="Both" />
				</RadioGroup>
				{
					(pricing) ?
						<ShowPricing community={community} openPricing={pricing} setOpenPricing={setPricing}  />
						: null
				}
			</div>
			<div style={{marginTop: 20}}>
				<button disabled={!props.accepted} className={"btn-register"}
				        onClick={() => props.setStep(1)}
				>START
				</button>
			</div>
		</>
	)
	
}

const ShowPricing = (props) => {
	
	const [pricing, setPricing] = useState('');
	const [pricingCommunity, setPricingCommunity] = useState('');
	
	useEffect(() => {
		
		fetch(pricingMarkdownFile)
			.then((r) => r.text())
			.then(text => {
				setPricing(text);
			})
		
		fetch(pricingMarkdownFileCommunity)
			.then((r) => r.text())
			.then(text => {
				setPricingCommunity(text);
			})
		
	}, [])
	
	return (
		<Dialog
			open={props.openPricing}
			onClose={() => props.setOpenPricing(false)}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			scroll={"paper"}
		>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					<div className={"markdown-pricing"}>
						<ReactMarkdown
							remarkPlugins={[[remarkGfm, {singleTilde: false}]]}>{(props.community) ? pricingCommunity : pricing }
						</ReactMarkdown>
					</div>
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => props.setOpenPricing(false)} autoFocus>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	)
}

const Favicon = () => {
	return (
		<>
			<img src={paw} style={{height: 15, marginRight: 10}}/>
		</>
	)
}

const PageHowWork = () => {
	
	return (
		<>
			<h3>How do they work?</h3>
			<p>All Snip ‘n’ Chip campaigns run through <a href={"https://book.spcadesexing.nz"} target={"_blank"}>book.spcadesexing.nz</a> and vouchers are
				valid until the campaign end date. All Community Desexing vouchers are issued by SPCA staff through a separate portal and are valid for three months from date of issue. </p>
			<ul>
				<li><Favicon/>Snip ‘n’ Chip clients will be instructed to visit the booking website to register for a
					voucher. They will enter their address, contact details, and animal information and select a
					participating veterinary clinic. For Community Desexing, SPCA staff will do this on their behalf
					through the staff portal.
				</li>
				<li><Favicon/>An automatic email will be sent to the owner with their voucher(s) and contact details of
					the veterinary clinic.
				</li>
				<li><Favicon/>The owner will be instructed to contact the veterinary clinic and arrange their desexing
					appointment.
				</li>
				<li><Favicon/>Depending on the type of campaign/voucher the owner will pay the voucher price (per
					animal) to the clinic on/before the day of surgery.
				</li>
			</ul>
			
			<ul>
				<li><Favicon/>Each participating veterinary clinic will have a login for the online online desexing system.
				</li>
				<li><Favicon/>Within the system you will be able to see all vouchers assigned to your clinic – Snip ‘n’
					Chip and/or Community Desexing.
				</li>
				<li><Favicon/>Each animal will have an an individual voucher number assigned by the system.
				</li>
				<li><Favicon/>Veterinary clinics will redeem vouchers through the online system once the surgery has
					been completed.
				</li>
				<li><Favicon/>The microchip number is entered into the system by the clinic to trigger registration on
					NZCAR.
				</li>
				<li><Favicon/>The system will automatically email you the total amount to be invoiced each month.</li>
			</ul>
			
			<p>The Snip ‘n’ Chip campaign will be marketed primarily using social media and the SPCA website. Where
				necessary, we will also advertise around the community, in local newspapers, through schools and other
				media outlets. As most Snip ‘n’ Chip campaigns run for at least 3 months, advertising will be ongoing as
				needed. There will be no marketing or advertising for Community Desexing.
			</p>
		
		</>
	)
}

const PageHowRemuneration = () => {
	
	return (
		<>
			<h3>How are veterinary clinics remunerated? </h3>
			
			<p>We will subsidise the cost of this desexing (per animal) at veterinary clinics. Our prices
				are detailed separately in the next section.</p>
			<p>On the 3rd of each month an automatic email (“schedule”) will be sent to your account’s person
				summarising the redeemed vouchers (for the previous month) and total amount required to be invoiced by
				your clinic.</p>
			<p>The total amount noted in the schedule and on your invoice/statement must match to be processed by our
				accounting system. Creating a separate SPCA Desexing account will ensure any unrelated costs are
				not included in your statement.</p>
			<p>
				If you are participating in both Snip ‘n’ Chip and Community Desexing, you will be able to redeem and invoice both types of vouchers in the same way.
			</p>
			<p>All invoices must to be addressed to RNZSPCA Inc. and emailed to <a href={"mailto:accounts@spca.nz"}
			                                                                       style={{border: 'none'}}
			                                                                       target={"_blank"}>accounts@spca.nz</a>.
			</p>
		
		</>
	)
}

const PageRecognition = () => {
	return (
		<>
			<h3>How will your veterinary clinic be recognised?</h3>
			<p>In thanks and recognition of your participation we will promote your clinic in the following ways:</p>
			<ul>
				<li><Favicon/>Promotion via SPCA website and Facebook page</li>
				<li><Favicon/>SPCA email newsletter</li>
				<li><Favicon/>Articles in local newspaper (as needed)</li>
				<li><Favicon/>Ongoing updates in Vet Script and/or other publications (when appropriate)</li>
			</ul>
		</>
	)
}

const Footer = () => {
	return (
		<footer>
			<ul>
				<li><a href="#"><i className="fa fa-twitter-square"></i></a></li>
				<li><a href="#"><i className="fa fa-facebook-square"></i></a></li>
				<li><a href="#"><i className="fa fa-snapchat-square"></i></a></li>
				<li><a href="#"><i className="fa fa-pinterest-square"></i></a></li>
				<li><a href="#"><i className="fa fa-github-square"></i></a></li>
			</ul>
			<p>SPCA @ 2022 | All rights reserved</p>
		</footer>
	)
}




